import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http'
import { Observable, of } from 'rxjs';
import { catchError, map, tap, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { eResponse, eLead, eClick, ePicture, eFAQ, ePlan } from './entities';
import { environment } from '../../../environments/environment';
import { AlertService } from './alert.service';
import { MasterService } from './master.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class HaylieService {

  API_ROOT = environment.apiUrl;
  server = this.API_ROOT;
  hlp = environment.apiUrl;
  l_target = '';
  
  endpoint_gallery = 'content/getgallery?p_bot=wanda&p_filter=gallery&p_param=clientrequest_nf';
  endpoint_lead = 'player/lead?p_bot=wanda&p_param=clientrequest_nf';
  endpoint_partner = 'partner/save?p_bot=wanda&p_param=clientrequest_nf';
  endpoint_click_set = 'content/SaveClick?p_bot=wanda&p_param=clientrequest_nf';

  endpoint_plans_get = 'plan/getall?p_bot=wanda&p_param=clientrequest_nf';
  endpoint_faqs_get = 'faq/getall?p_bot=wanda&p_param=clientrequest_nf';

  endpoint_agenda_get = 'api/agenda/getall?p_bot=wanda&p_param=clientrequest_nf';
  //endpoint_agenda_set = 'api/agenda/save?p_bot=wanda&p_param=clientrequest_nf&';
  endpoint_class_gettoday = 'api/class/gettoday?p_bot=wanda';
  endpoint_class_get = 'api/class/getall?p_bot=wanda';

  constructor(private http: HttpClient, 
              private _svc_master: MasterService,
              private _svc_alert: AlertService) { }
  
  get_gallery(): Promise<ePicture[]> {
    this.l_target = this.server + this.endpoint_gallery;

    return this.http
    .get<ePicture[]>(this.l_target, httpOptions)
    .pipe(
      map((response: any) => response.Value)
    )
    .toPromise()
  }

  get_classes(p_day:string): Promise<any[]> {
    let l_params = "&p_param=clientrequest_nf";
    this.l_target = this.server + this.endpoint_class_get + l_params;

    return this.http
    .get<any[]>(this.l_target, httpOptions)
    .pipe(
      map((response: any) => response.Value)
    )
    .toPromise()

  }
  get_classestoday(p_day:string): Promise<any[]> {
    let l_params = "&p_param=clientrequest_nf";
    this.l_target = this.server + this.endpoint_class_gettoday + l_params;

    return this.http
    .get<any[]>(this.l_target, httpOptions)
    .pipe(
      map((response: any) => response.Value)
    )
    .toPromise()

  }

  send_frm(p_lead: eLead, p_type: string):void {
    var cDate = new Date();
    console.log('sending frm - ' + cDate.getUTCDate());

    var l_params = "&p_name=" + p_lead.name + "&p_birth=" + p_lead.birth + "&p_mail=" + p_lead.mail + "&p_phone=" + p_lead.phone;
    
    if (p_type == "talk")
      this.l_target = this.server + this.endpoint_lead + l_params;
    else { 
      l_params = "&p_name=" + p_lead.name + "&p_company=reg-" + p_type + "&p_cnpj=01002003000405&p_id=0" + 
                 "&p_mail=" + p_lead.mail + "&p_phone=" + p_lead.phone;
    
      this.l_target = this.server + this.endpoint_partner + l_params;
    }
    let trythis = this.http
    .get(this.l_target, httpOptions)
    .pipe(
      map((response: any) => response.Value), 
      finalize(() => { this._svc_master.trg_master("loading"); })
    ).subscribe({ 
      next: () => { 
        this._svc_alert.success('ok'); 
      }
      //complete: () => { this._svc_alert.show(); }
    });
  
    console.log('lead test>' + trythis);
  
  }

  send_lead(p_lead: eLead):void {
    var cDate = new Date();
    console.log('sending lead - ' + cDate.getUTCDate());

    var l_params = "&p_name=" + p_lead.name + "&p_birth=" + p_lead.birth + "&p_mail=" + p_lead.mail + "&p_phone=" + p_lead.phone;
    
    this.l_target = this.server + this.endpoint_lead + l_params;
    
    let trythis = this.http
    .get(this.l_target, httpOptions)
    .pipe(
      map((response: any) => response.Value), 
      finalize(() => { this._svc_master.trg_master("loading"); })
    ).subscribe({ 
      next: () => { this._svc_alert.success('ok'); }
      //complete: () => { this._svc_alert.show(); }
    });
  
    console.log('lead test>' + trythis);
  
  }

  send_click(p_agenda: eClick):void {
    var l_params = "";
    var cDate = new Date();
    console.log('sending lead - ' + cDate.getUTCDate());
    
    this.l_target = this.server + this.endpoint_click_set + l_params;
    
    let trythis = this.http
    .post(this.l_target, httpOptions)
    .pipe(
      map((response: any) => response.Value)
    )
    .subscribe({ 
      next: () => { 
        //this._svc_alert.success('ok'); 
      }
      //complete: () => { this._svc_alert.show(); }
    });

    console.log('whats>' + trythis);
    
  }


  get_plans(): Observable<ePlan[]> {
    const url = this.server + this.endpoint_plans_get;

    return this.http.get<any>(url, httpOptions)
    .pipe(
      map(res => {
        if (!res) return [];

        let source: any;

        try {
          source = typeof res === 'string'
            ? JSON.parse(res)
            : res ?? res;

          source = typeof source.Value === 'string'
            ? JSON.parse(source.Value)
            : source.Value ?? res;
        } catch (e) {
          console.error('Parse error:', res.Value);
          return [];
        }

        return source?.plans ?? [];
      }),
      catchError(err => {
        console.error('HTTP error:', err);
        return of([]);
      })
    );
  }

  get_faqs(): Observable<eFAQ[]> {
    const url = this.server + this.endpoint_faqs_get;

    return this.http.get<any>(url, httpOptions).pipe(
      map(res => {
        if (!res) return [];

        let source: any;

        try {
          source = typeof res === 'string'
            ? JSON.parse(res)
            : res ?? res;

          source = typeof source.Value === 'string'
            ? JSON.parse(source.Value)
            : source.Value ?? res;
        } catch (e) {
          console.error('Parse error:', res.Value);
          return [];
        }

        return source?.FAQs ?? [];
      }),
      catchError(err => {
        console.error('HTTP error:', err);
        return of([]);
      })
    );
  }


}
